<template>
  <section>
    <draggable ghost-class="ghost" :list="selectedSection.items" @start="isDragging = true" @end="isDragging = false">
      <transition-group type="transition" name="list-complete">    
        <v-row no-gutters v-for="(opt, index) in selectedSection.items" :key="index" class="pb-4 _cursor-move">
          <v-col cols="6" class="_pr-">
            <TextField v-model="opt.number" :label="`Valor ${index + 1}`"/>        
          </v-col>

          <v-col cols="6" class="_pl-">
            <TextField v-model="opt.description" :label="`Texto ${index + 1}`"/>          
          </v-col>

          <v-col cols="12" class="pt-5">
            <div class="d-flex justify-end">
              <DeleteButton @click="handleDelete(selectedSection.items, index)"/>       
            </div>
          </v-col>
        </v-row>
      </transition-group>
    </draggable>        

    <v-row no-gutters class="d-flex flex-column btn py-2">
      <Button 
        label="Adicionar opção" 
        color="bt_gray_bg"
        textColor="darkBlue"
        textSize="0.80rem"
        icon="fa-solid fa-link"
        @click="handleAdd"
      />      
    </v-row>
  </section>    
</template>

<script>
import draggable from 'vuedraggable'
import { NUMBERS_ITEM_OPTION } from '../../../../schemas/sections'
import TextField from '../../../_v2/ui/TextField.vue'
import DeleteButton from '../../../_v2/ui/DeleteButton.vue'
import Button from '../../../_v2/ui/Button.vue'

export default {
  name: 'NumberOptions',
  components: {draggable, TextField, DeleteButton, Button},
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true},
  },
  
  data: () => ({
    isDragging: false
  }),     

  methods: {
    handleDelete(options, index) {
      options.splice(index, 1)
    },

    handleAdd () {
      this.selectedSection.items.push(NUMBERS_ITEM_OPTION())
    }
  }
}
</script>

<style scoped>
.btn {
  transition: all 0.3s;
}

.btn button:hover {
  background-color: #CBCBCE !important;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
  cursor: move !important;
}

.list-complete-item {
  transition: all 0.8s;
  display: inline-block;
  margin-right: 10px;
}

.list-complete-enter, .list-complete-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}

.list-complete-leave-active {
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
}
</style>